import { render, staticRenderFns } from "./AddTaskList.vue?vue&type=template&id=c7912cf8"
import script from "./AddTaskList.vue?vue&type=script&lang=js"
export * from "./AddTaskList.vue?vue&type=script&lang=js"
import style0 from "./AddTaskList.vue?vue&type=style&index=0&id=c7912cf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports